<template>
  <AppLayoutContainerSmall class="social-block">
    <div class="social-block__inner">
      <div v-if="data.vendor === 'facebook'" class="social-block__content fb-post" :data-href="data.embed_url" data-width="500"
           data-show-text="true">
        <blockquote :cite="data.embed_url" class="fb-xfbml-parse-ignore">
          <a :href="`${data.embed_url}`">Facebook</a>
        </blockquote>
      </div>

      <blockquote v-else-if="data.vendor?.toLowerCase() === 'twitter'" class="twitter-tweet" data-lang="nl">
        <a :href="`${data.embed_url}`"/>
      </blockquote>

      <iframe title="instagram" v-else-if="data.vendor?.toLowerCase() === 'instagram'"
              :src="`${data.embed_url}embed/captioned`"
              frameborder="0"
              scrolling="no" allowtransparency="true" height="500">
        <a :href="`${data.embed_url}`"/>
      </iframe>

      <iframe title="tiktok" v-else-if="data.vendor?.toLowerCase() === 'tiktok'" :src="`${data.embed_url}`" frameborder="0"
              scrolling="no" allowtransparency="true" height="570">
        <a :href="`${data.embed_url}`"/>
      </iframe>

      <div v-else-if="data.vendor?.toLowerCase() === 'spotify'" class="social-block__spotify">
        <iframe title="spotify" :src="`${data.embed_url}`" frameborder="0" scrolling="no" allowtransparency="true" height="80" class="social-block__iframe">
          <a :href="`${data.embed_url}`" />
        </iframe>
      </div>

      <AppJotformEmbed v-else-if="data.vendor?.toLowerCase() === 'jotform' && data.embed_url" :id="data.id" :embed-url="data.embed_url" />

      <!-- fallback, default iframe with url -->
      <iframe title="generic" v-else :src="`${data.embed_url}`" frameborder="0"
              scrolling="no" allowtransparency="true" height="500">
        <a :href="`${data.embed_url}`"/>
      </iframe>

      <small v-if="data.caption" class="social-block__small">{{ data.caption }}</small>
    </div>
  </AppLayoutContainerSmall>
</template>

<script setup lang="ts">
import { TArchiveSocialBlock } from '~/types/block-archive-types'
import { useCdnStore } from '~/store/cdn.client'

const cdnStore = useCdnStore()

const props = defineProps<{
  data: TArchiveSocialBlock
}>()

onMounted(() => {
  if (props.data.vendor?.toLowerCase() === 'facebook') {
    cdnStore.loadFacebook()
  }

  if (props.data.vendor?.toLowerCase() === 'twitter') {
    cdnStore.loadTwitter()
  }
})
</script>

<style scoped lang="postcss">
.social-block {
  &__inner {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.5rem;
  }

  &__content {
    background-color: #fff;
  }

  &__spotify {
    width: 100%;
  }

  &__iframe {
    width: 100%;
  }

  &__small {
    display: block;
    @mixin app-caption-wide;
  }
}

/* the FB SDK sets a fixed pixel width (552px for reels) inline on the widget, wider than a phone */
.social-block__content,
.social-block__content :deep(span),
.social-block__content :deep(iframe) {
  max-width: 100% !important;
}

/* no scoped + important needed to overrule embed styles */
.twitter-tweet {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}
</style>
